import GooglePlay from '@/assets/icons/google-pl.svg?react'
import GoogleStore from '@/assets/icons/google-store.svg?react'

import { URLS } from '@/pages/urls'
import { Button, Text } from '@/ui-kit'
import { Link } from '@/ui-kit/components/Link'
import { useUiKit } from '@/ui-kit/providers'
import clsx from 'clsx'
import styles from '../../restricted-data/components/RestrictedDataBanner.module.css'

export const NoDevicesPlaceholder = () => {
  const { isThemeDark } = useUiKit()

  return (
    <div className={clsx(styles.gradient, 'mx-auto max-h-min w-full !max-w-[1024px] overflow-hidden hover:!scale-100')}>
      <div className={clsx(styles.container, 'max-mobile:flex-col relative flex h-min flex-row gap-8 overflow-hidden')}>
        {isThemeDark ? (
          <img
            src="/images/bg-placeholder.png"
            className="max-mobile:scale-150 max-mobile:border-t absolute top-0 left-0 w-full -rotate-180 border-solid border-gray-100"
          />
        ) : (
          <img
            src="/images/bg-placeholder-white.png"
            className="max-mobile:scale-150 max-mobile:border-t absolute top-0 left-0 w-full border-solid border-gray-100"
          />
        )}
        <div className="max-mobile:order-2 max-mobile:mt-0 max-mobile:justify-center max-mobile:mx-4 z-[1] my-[72px] ml-8 flex max-w-[490px] flex-grow flex-col gap-8">
          <Text type="h2" className="max-mobile:text-center text-start">
            Earn by passively collecting data for AI
          </Text>
          <div className="max-mobile:gap-4 flex flex-wrap justify-start gap-2">
            <Link
              variant="bordered"
              href={URLS.EXTENSION_INSTALL}
              target="_blank"
              rel="noreferrer"
              className="max-mobile:flex-grow"
            >
              <div className="flex gap-2">
                <GoogleStore />
                Download our extension
              </div>
            </Link>
            <Button
              variant="secondary"
              className="max-mobile:max-w-full max-mobile:flex-grow max-w-[190px]"
              onClick={() => window.open('https://play.google.com/store/apps/details?id=acl.datahive.app')}
            >
              <GooglePlay />
            </Button>
          </div>
        </div>
        <div className="max-mobile:order-1 max-mobile:mx-auto max-mobile:mt-8 max-mobile:h-[138px] max-mobile:w-[146px] z-[1] mr-12 ml-auto w-[238px] flex-shrink-[0.5] overflow-hidden object-contain">
          <img src="/images/phone.png" className="object-contain" />
        </div>
      </div>
    </div>
  )
}
